import { cacheFirstConfig, http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { PositionStatus } from './position-status.interface';

export class PositionStatusService {
   async getPositionStatuses() {
      const response = await http.get<ApiResource<Array<PositionStatus>>>(`/position-statuses`, {
         ...cacheFirstConfig,
      });
      return response.data;
   }

   async getPositionStatus() {
      throw Error('Method not implemented');
   }

   async postPositionStatus() {
      throw Error('Method not implemented');
   }

   async putPositionStatus() {
      throw Error('Method not implemented');
   }

   async deletePositionStatus() {
      throw Error('Method not implemented');
   }
}
